const data = [
  {
    image:
      "https://www.horecatrend.com/wp-content/uploads/2022/12/McDonalds4-300x200.jpeg",
    name: "McDonald's",
    icerik: "American - Fast Food - Burgers",
    zaman: "20-30 Min",
    fiyat: "$5.99 Delivery Fee",
  },

  {
    image:
      "https://cdnassets.hw.net/dims4/GG/b647ae9/2147483647/thumbnail/300x200%3E/quality/90/?url=https%3A%2F%2Fcdnassets.hw.net%2Fc9%2F62%2F05f3051847c99abf778618c7c6be%2F8a7208cc13954465b39879d880c4cd58.jpg",
    name: "Sweetgreen",
    icerik: "Healthy - Salade",
    zaman: "30-45 Min",
    fiyat: "$7.99 Delivery Fee",
  },

  {
    image:
      "https://cdn.yemek.com/mncrop/300/200/uploads/2018/07/starbucks-acemi.jpg",
    name: "Starbucks",
    icerik: "Cafe - Coffee & Tea - BreakFast and Brunch",
    zaman: "20-30 Min",
    fiyat: "$3.99 Delivery Fee",
  },

  {
    image:
      "https://cdn.yemek.com/mncrop/300/200/uploads/2018/07/starbucks-acemi.jpg",
    name: "Starbucks",
    icerik: "Cafe - Coffee & Tea - BreakFast and Brunch",
    zaman: "20-30 Min",
    fiyat: "$3.99 Delivery Fee",
  },

  {
    image:
      "https://www.gida2000.com/wp-content/uploads/2021/12/Gloria-Jeans-Magaza-300x200.jpg",
    name: "Gloria Jean's ",
    icerik: "Roasted Arabica Coffee Beans",
    zaman: "20-30 Min",
    fiyat: "$4.99 Delivery Fee",
  },

  {
    image:
      "https://www.horecatrend.com/wp-content/uploads/2022/12/McDonalds4-300x200.jpeg",
    name: "McDonald's",
    icerik: "American - Fast Food - Burgers",
    zaman: "20-30 Min",
    fiyat: "$5.99 Delivery Fee",
  },
];

export default data;
